import React from "react"






function Footer (props){

  const footerStyle ={
    color: 'white',
    backgroundColor:'#012782',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    paddingBottom: 'ovh'
  
  }

  return(
    <div className="containe-fuild" style={footerStyle}>
      <div className=" row footer-copyright text-center pt-5 pb-1 justify-content-center">
        <div className="col-10">
        
        <p> <small>서울시 서대문구 신천동 134 연세대학교 생명시스템대학 생면공학과 우편번호: 120-749 TEL: 02-2123-2881 FAX: 02-362-7265
        실험실 주소: 서울시 서대문구 신촌동 134 연세대학교 제2공학관 B411호 분자바이러스학 연구실</small> </p>
        <p> <strong>© 2019 Molecular Virology Lab. All Rights Reserved</strong> </p>
        </div>
      </div>
    </div>
  )
}

export default Footer